module.exports = __webpack_public_path__ + "img/receiveImg.fb9cd91d.png";